import { RadialProgressBar, Typography } from "@hellocarbo/lasagne";

import Card from "../ui/Card";

type ProgressProps = {
  title: string;
  completed: number;
  total: number;
  isCompleted: boolean;
  percentage?: number;
};
const Progress = ({
  title,
  completed,
  total,
  percentage,
  isCompleted,
}: ProgressProps) => {
  return (
    <Card className="px-m gap-sm border-grayscale-xx-light py-sm col-span-3 flex flex-row-reverse items-center justify-end border lg:flex-row lg:justify-between">
      <div className="flex flex-col items-start">
        <Typography step="0" as="h3" weight="semibold">
          {title}
        </Typography>
      </div>
      <RadialProgressBar
        percentage={percentage ? percentage : (completed / total) * 100}
        completed={isCompleted}
      />
    </Card>
  );
};

export default Progress;
